import { useState } from 'react';
import Link from 'next/link';
import styled from 'styled-components';
import { useSelector } from 'src/store/store';
import Card from 'src/components/card';
import i18n from 'src/utils/translate';
import { trackFootfallEvent } from 'src/utils/footfall';
import { Event, Element, Section } from 'src/constants/footfall';
import Button from 'src/components/buttons/button';
import { titleSmall } from 'styles-js/mixins/typography';
import { Topic as TopicType } from 'src/constants/types';
type Props = {
  topics: TopicType[];
};
export default function TopicList({
  topics = []
}: Props) {
  const [isShowAll, setIsShowAll] = useState(false);
  const communitySlug = useSelector(({
    context
  }) => context.currentCommunity?.slug);
  if (topics.length === 0) return null;
  const sortedTopics = [...topics].sort((a, b) => b.postCount - a.postCount);
  const topicList = isShowAll ? sortedTopics : sortedTopics.splice(0, 5);
  const totalCount = topics.reduce((total, c) => total + c.postCount, 0);
  return <Card title={i18n.t('Topics')} data-sentry-element="Card" data-sentry-component="TopicList" data-sentry-source-file="topicList.tsx">
      <Topic data-sentry-element="Topic" data-sentry-source-file="topicList.tsx">
        <Link legacyBehavior passHref as={`/${communitySlug}/posts`} href={`/community/communityPosts?communitySlug=${communitySlug}`} data-sentry-element="Link" data-sentry-source-file="topicList.tsx">
          <StyledLink data-sentry-element="StyledLink" data-sentry-source-file="topicList.tsx">
            {i18n.t('All posts')}({totalCount})
          </StyledLink>
        </Link>
      </Topic>
      {topicList.map(({
      id,
      name,
      postCount
    }) => <Topic key={id}>
          <Link legacyBehavior passHref as={`/${communitySlug}/posts/topic/${encodeURIComponent(name.toLowerCase())}`} href={`/community/communityPosts?communitySlug=${communitySlug}&topicName=${encodeURIComponent(name.toLowerCase())}`}>
            <StyledLink onClick={() => {
          trackFootfallEvent(Event.Clicked, {
            clickType: 'post-side-bar',
            clickMetadata: {
              section: Section.PostsSideBar,
              element: Element.Topic
            }
          });
        }}>
              {name}({postCount})
            </StyledLink>
          </Link>
        </Topic>)}
      {!isShowAll && topics.length > 5 && <Button icon="open-down" iconPosition="right" text={i18n.t('See all topics')} type="link" onClick={() => {
      setIsShowAll(true);
      trackFootfallEvent(Event.Clicked, {
        clickType: 'post-side-bar',
        clickMetadata: {
          section: Section.PostsSideBar,
          element: Element.SeeAllTopics
        }
      });
    }} />}
    </Card>;
}
const Topic = styled.div`
  margin-bottom: 12px;
`;
const StyledLink = styled.a`
  ${titleSmall};
  &:hover, &:focus, &:active {
    color: ${({
  theme
}) => theme.colorGreyDark};
  }
`;